import { createTheme, ThemeOptions } from '@mui/material/styles';

// DealerOS Marketplace Theme - matches your existing brand colors
export const marketplaceThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#007aff',    // iOS blue for light mode
      light: '#5ac8fa',
      dark: '#0051d5',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#161616',    // Your actual DARK secondary
      light: '#282828',
      dark: '#0a0a0a',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8f8f8',  // Light gray background
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#666666',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 900,
      fontSize: '3.5rem',
      letterSpacing: '-1px',
      color: '#1a1a1a',
      '@media (max-width:900px)': {
        fontSize: '2rem',
      },
    },
    h2: {
      fontWeight: 900,
      fontSize: '3rem',
      letterSpacing: '-1px',
      color: '#1a1a1a',
      '@media (max-width:900px)': {
        fontSize: '1.75rem',
      },
    },
    h3: {
      fontWeight: 800,
      fontSize: '2.5rem',
      color: '#1a1a1a',
      '@media (max-width:900px)': {
        fontSize: '1.5rem',
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
      color: '#1a1a1a',
    },
    h5: {
      fontWeight: 700,
      fontSize: '1.5rem',
      color: '#1a1a1a',
    },
    h6: {
      fontWeight: 700,
      fontSize: '1.25rem',
      color: '#1a1a1a',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
    body1: {
      lineHeight: 1.6,
    },
    body2: {
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          backgroundColor: '#007aff',
          '&:hover': {
            backgroundColor: '#5ac8fa',
          },
        },
        outlined: {
          borderWidth: '1px',
          '&:hover': {
            borderWidth: '1px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e0e0e0',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation0: {
          boxShadow: 'none',
        },
        elevation1: {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
        elevation2: {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.10)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
  },
};

// Create and export the marketplace theme
export const marketplaceTheme = createTheme(marketplaceThemeOptions);
export default marketplaceTheme;